import { Container, Divider, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { InputCheck } from "../../controls";
import { useEffect } from "react";
import { useContext } from "react";
import { AppContext } from "../../App";
import { useTranslation } from "react-i18next";
import { action, controller, Server } from "../../api/Server";
import { ToFormData } from "../../hooks/Method";
import SearchCats from "./SearchCats";

const PosCats = () => {
  const { t } = useTranslation();
  const { setLoader, setPageTitle } = useContext(AppContext);
  const [fltCats, setFltCats] = useState([]);
  const [cats, setCats] = useState([]);

  useEffect(() => {
    setPageTitle && setPageTitle(t("posCategories"));

    setLoader(true);
    Server(controller.Category + action.GetAllByOrg).get((res) => {
      setLoader(false);
      if (res && res.status === 200) {
        setCats([...res.result]);
        setFltCats([...res.result]);
      }
    });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e, categoryId) => {
    var val = e.target.checked;
    setLoader(true);
    Server(controller.PosDefaultCat + action.SetAndRemovePosCat).post(
      ToFormData({ categoryId: categoryId, isDefaultPosCat: val }),
      (res) => {
        setLoader(false);
        res.status === 200
          ? console.log("success")
          : console.error("Error: ", res);
      }
    );
  };

  return (
    <Container maxWidth="md">
      <Paper className="br-8 shadow-xs p-20">
        <Box className="tx-center mb-20">
          <Typography variant="subtitle1" className="fs-22 fw-5 gray-color">
            {t("posCategories")}
          </Typography>
          <div className="bs-bottom mx-w-60 m-auto" />
        </Box>
        <Box className="tx-center mb-20">
          <SearchCats {...{ cats, setFltCats }} />
        </Box>

        <Box
          sx={{
            height: "calc(100vh - 310px)",
            overflow: "auto",
            padding: "10px",
          }}
        >
          {fltCats.map((cat, i) => (
            <div key={i}>
              <InputCheck
                onChange={(e) => handleChange(e, cat.categoryId)}
                label={`${cat.categoryName} (Total Products: ${cat.productCount})`}
                defaultChecked={cat.isDefaultPosCategory}
              />
              <Divider />
            </div>
          ))}
        </Box>
      </Paper>
    </Container>
  );
};

export default PosCats;
